import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "Restaurant",
  "name": "Casa Loco",
  "url": "https://www.casaloco.in",
  "logo": "https://customer-assets.emergentagent.com/job_casaloco-flavors/artifacts/mrxtkbpi_Casa%20Loco%20Logo%20%285%29.png",
  "image": "https://customer-assets.emergentagent.com/job_casaloco-flavors/artifacts/mrxtkbpi_Casa%20Loco%20Logo%20%285%29.png",
  "description": "Best Mexican restaurant in Hyderabad and Chennai. Authentic Mexican street food — tacos, burritos, nachos, enchiladas and more at Casa Loco and Casa Loco Express.",
  "servesCuisine": ["Mexican", "Tex-Mex"],
  "keywords": "Best Mexican restaurant in Hyderabad, Mexican food Chennai, Casa Loco Express, best tacos in Hyderabad",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "2nd Floor, Radisson Hitec City, Gachibowli",
    "addressLocality": "Hyderabad",
    "addressRegion": "Telangana",
    "postalCode": "500032",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 17.44764860443804,
    "longitude": 78.36304744417907
  },
  "telephone": "+918790896655",
  "email": "hola@casaloco.in",
  "priceRange": "$$",
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    "opens": "12:00",
    "closes": "23:00"
  },
  "sameAs": [
    "https://www.instagram.com/casalocoindia/",
    "https://www.facebook.com/casalocoindia/",
    "https://www.linkedin.com/company/casalocoindia"
  ]
};

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(localBusinessSchema)}
        </script>
      </Helmet>
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Layout;